import { Component, OnInit, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';


@Component({
  selector: 'mcrit-gestio-manage-project-control-tecnic',
  templateUrl: 'control-tecnic.component.html',
  styleUrls: ['control-tecnic.component.css', '../list-cards.css']
})

export class ControlTecnicComponent implements OnInit {
  @Input() aggregates: any;
  @Input() totalHores: any;

  getHoresPendents = function(){
    if(isNaN(this.totalHores))return 0.0;
    if(!this.aggregates)return 0.0;
    if(isNaN(this.aggregates.total))return this.totalHores;
    return (this.totalHores - this.aggregates.total);
  }

  getNumber(val: any) {
    if (isNaN(val)) return 0;
    return +val;
  }

  constructor(public translate: TranslateService, public languageService: LanguageService ) { }

  ngOnInit() {}

}
